import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PublicNavigationComponent } from "../public-navigation/public-navigation.component";
import { PublicFooterComponent } from "../footer/footer.component";

@Component({
  selector: 'app-price',
  imports: [CommonModule, RouterModule, PublicNavigationComponent, PublicFooterComponent],
  templateUrl: './price.component.html',
  styleUrl: './price.component.scss'
})
export class PriceComponent {}
